<template>
  <v-card min-width="21vw" align="center" justify="center" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_AddBrokerAccount') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 pt-7">
      <v-form v-model="valid">
        <v-autocomplete @change="printChoosed()" :label="$t('broker_AddBrokerAccount')" :items="brokers" item-text="name" item-value="id" :rules="brokerRule"
                        :hint="$t('brokerHint_AddBrokerAccount')" v-model="brokerChoosed" outlined/>
        <v-text-field v-if="brokerChoosed !== 0"
                      :label="$t((directIntegratedAccount || directDBIntegratedAccount || directAPIIntegratedAccount)? 'metaTraderCredentials.identifier' : 'identifier')"
                      v-model="accountId" :rules="(directIntegratedAccount || directDBIntegratedAccount || directAPIIntegratedAccount )? loginRules : []" outlined/>
        <v-select v-if="directIntegratedAccount || (brokerChoosed == 571 && typeChoosed === 'Demo')" :label="$t('metaTraderCredentials.server')" :return-object="true" :items="servers" item-text="name"
                  v-model="server" :rules="serverRules" outlined/>
        <v-text-field v-if="directAPIIntegratedAccount" :label="$t( 'accountPassword')"
                      v-model="accountPassword" :rules="passwordRules" outlined/>
        <v-text-field v-if="(brokerChoosed == 571) ? typeChoosed === 'Live' : (brokerChoosed !== 0 && directDBIntegratedAccount)" :label="$t('email.label', {broker: this.brokerChoosedName})" v-model="integrationEmail" :rules="emailRule" outlined/>
        <v-select v-if="brokerChoosed !== 0 && !directIntegratedAccount" :label="$t('type_AddBrokerAccount')" :items="brokerChoosed == 571 ? ['Demo','Live'] : directDBIntegratedAccount ? ['Live'] : accountTypes"
                  :rules="accountTypeRule" v-model="typeChoosed"
                  outlined/>
        <v-select v-if="brokerChoosed !== 0 && !directIntegratedAccount && !directAPIIntegratedAccount && !directDBIntegratedAccount" :label="$t('currency_AddBrokerAccount')" :items="currencies"
                  :rules="currencyRule" v-model="currencyChoosed" outlined/>
        <v-chip v-if="directIntegratedAccount" class="my-3" color="mainGreen">
          {{ $t('metaTraderCredentials.alert') }}
        </v-chip>
        <p v-if="directIntegratedAccount" style="font-size: 15px; color: #6b6b6b" class="text-center mb-7"
           v-html="$t('metaTraderCredentials.complianceUrl')"/>
           
        <!-- MT5 Auto Sync Notice -->
        <v-alert
          color="darkGreen"
          text
          class="mb-4"
          border="left"
          dense
          v-show="brokerChoosed == 0"
        >
          <div>
            <v-icon small color="darkGreen" class="mr-2">fa-info-circle</v-icon>
            <span style="color: var(--v-darkGreen-base) !important; font-size: 14px; font-family: 'Avenir';">{{ $t('mt5AutoSync.info') }} </span>
            <a 
              class="font-weight-medium darkGreen--text" 
              @click.prevent="goToMT5Connect" 
              style="text-decoration: underline; cursor: pointer; font-size: 14px;"
            >{{ $t('mt5AutoSync.link') }} <v-icon x-small color="darkGreen">fa-external-link-alt</v-icon></a>
          </div>
        </v-alert>
        
        <v-btn :disabled="!valid" @click="addBrokerAccount" class="mt-2">{{ $t('btnAdd_AddBrokerAccount') }}</v-btn>
      </v-form>
    </v-card-text>
  <v-progress-circular v-if="loading" indeterminate color="green"></v-progress-circular>
  <v-overlay :dark="false" v-model="modalSyncedV">
      <v-alert v-model="modalSyncedV" :title="modalTitle" closable close-label="Close Alert" :type="modalType">
        {{ modalText }}
        <v-btn class="closeButton" @click="() => closeAlert()">Ok</v-btn>
      </v-alert>
    </v-overlay>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import RepositoryBrokerAccount from '../../../repositories/brokerAccount';
import RepositoryMetaTrader from '../../../repositories/metaTraderCredentials';
import BrokerApiCredentialRepo from '../../../repositories/brokerApiCredential';

export default {
  name: "AddBrokerAccount",
  data() {
    return {
      valid: false,
      accountTypes: ['Live', 'Demo'],
      brokersWithMT4IntegrationIds: [2,316,504,441,384, 559, 108, 615], // Should be obtained from db
      brokersWithAPIIntegrationIds: [68], // Should be obtained from db
      brokersWithDBIntegrationIds: [571], // Should be obtained from db
      servers: [
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo 2', host: 'demo.ava-mt-2.com' },
        //{ name: 'Equiti-Demo', host: 'demo.equiti-demo.com' },
        //{ name: 'Equiti-Live', host: 'demo.equiti-live.com' },
        //{ name: 'EquitiGroup-Demo', host: 'demo.equitigroup-demo.com' },
        //{ name: 'EquitiGroup-Live', host: 'demo.equitigroup-live.com' },
        //{ name: 'EquitiGroup-Live 2', host: 'demo.equitigroup-live-2.com' },
        
        {name: 'ZenfinexGlobal-Demo', host: '52.56.239.235', type: 'Demo'}, // Are managerAPI server's IPs secrets?
        {name: 'ZenfinexGlobal-Live', host: '18.168.113.125', type: 'Live'},
      ],
      xcube_servers:[
      ],
      brokers: [],
      accountId: '',
      integrationEmail: '',
      accountPassword: '',
      typeChoosed: 'Demo',
      brokerChoosed: 0,
      brokerChoosedName: '',
      modalText: "",
      modalTitle: "",
      modalType: "",
      modalSyncedV: false,
      loading:false,
      currencyChoosed: 'USD',
      currencies: [
        'USD',
        'AUD',
        'EUR',
        'GBP',
        'JPY',
        'BRL',
        'MXN',
        'COP',
        'CLP',
      ],
      server: '',

      // Rules
      emailRule: [
        e => !!e || this.$t('email.rule'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || 'Invalid email',
      ],
      brokerRule: [
        b => !!b || this.$t('validations_AddBrokerAccount.broker'),
      ],
      accountTypeRule: [
        a => !!a || this.$t('validations_AddBrokerAccount.type'),
      ],
      currencyRule: [
        c => !!c || this.$t('validations_AddBrokerAccount.currency'),
      ],
      loginRules: [
          l => !!l || this.$t('validations_AddBrokerAccount.login'),
      ],
      passwordRules: [
          l => !!l || this.$t('validations_AddBrokerAccount.password'),
      ],
      serverRules: [
        s => !!s || this.$t('validations_AddBrokerAccount.server'),
      ],
    };
  },
  computed: {
    directIntegratedAccount() {
      return this.brokersWithMT4IntegrationIds.findIndex((broker) => broker === this.brokerChoosed) !== -1;
    },
    directAPIIntegratedAccount() {
      return this.brokersWithAPIIntegrationIds.findIndex((broker) => broker === this.brokerChoosed) !== -1;
    },
    directDBIntegratedAccount() {
      return this.brokersWithDBIntegrationIds.findIndex((broker) => broker === this.brokerChoosed) !== -1;
    }
  },
  watch: {
    server() {
      if(this.brokerChoosed !== 571){
        this.typeChoosed = this.servers.find((s) => s.host === this.server.host).type;
      }
    },
    brokerChoosed() {
      let broker = this.brokerChoosed;
      this.brokerChoosedName = this.brokers.find((broker) => broker.id == this.brokerChoosed).name;
      if(this.directIntegratedAccount || this.brokerChoosed == 571)
        RepositoryBrokerAccount.serverDetailsByBroker(broker).then((response)=>{
          this.servers = response.data;
    })
    }
  },
  mounted() {
    this.loadBrokers();
  },
  methods: {
    async loadBrokers() {
      await RepositoryBrokerAccount.getAllBrokers().then((response) => {
        if (response.data.length > 0)
                response.data.forEach((item) => {
                  if(item.name!=="")
                    this.brokers.push(item);
                });
      });
      this.brokers.sort((one, two) => (one.name > two.name) ? 1 : (one.name < two.name) ? -1 : 0);
    },
    printChoosed(){
      // eslint-disable-next-line 
      console.log(this.brokerChoosed)
    },
    ...mapMutations(['setBrokerAccounts']),
    
    async addBrokerAccount() {
      if (this.valid) {
        let brokerAccount = {
          broker: { id: this.brokerChoosed },
          user: { id: this.$store.state.user.id },
          type: this.typeChoosed.toUpperCase(),
          identifier: this.accountId,
          currency: this.currencyChoosed,
        };
        
        // Creating their MetaTrader credentials
        if(this.directIntegratedAccount || (this.brokerChoosed === 571 && this.typeChoosed == 'Demo')){
          this.addDirectMTIntegratedAccount();
        }
        else if(this.directAPIIntegratedAccount){
          this.addDirectAPIIntegratedAccount();
        }else if(this.directDBIntegratedAccount){
          this.addDirectDBIntegratedAccount();
        }
        else{
          RepositoryBrokerAccount.createBrokerAccount(brokerAccount).then((response) => {
            if(response.status < 400) {
              alert(this.$t('createdAlert'));
              this.getAllBrokerAccounts();
            }
          });
          this.$emit('closeWindow');
        }
      }
    },

    async addDirectDBIntegratedAccount(){
      if(this.brokerChoosed === 571){
        let brokerIntegrationDTO = {
          login:this.accountId,
          type: this.typeChoosed.toUpperCase(),
          integrationEmail: this.integrationEmail,
          user: {id: this.$store.state.user.id},
          broker: {id: this.brokerChoosed},
        }
        this.loading = true;
        await RepositoryBrokerAccount.addGtcBrokerAccount(brokerIntegrationDTO).then((response) => {
          if (response.status < 400) {
            this.modalType = "success";
            this.modalText = this.$t('modal.success.text',{totalTrades: response.data});
            this.modalTitle = this.$i18n.messages[this.$i18n.locale]["modal"][this.modalType]["title"];
            this.modalSyncedV = true;
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.modalType = "error";
          this.modalText = this.$t('modal.error.text');
          this.modalTitle = this.$i18n.messages[this.$i18n.locale]["modal"][this.modalType]["title"];
          this.modalSyncedV = true;
          this.$emit(error);
        });
      }
    },
    async addDirectAPIIntegratedAccount(){
      let brokerName = this.brokers.find((broker) => broker.id == this.brokerChoosed).name;
      let apiCredential = {
        apiKey: this.accountPassword,
        secret: this.accountPassword,
        apiCredentialType: brokerName== "X-TRADE BROKERS (XTB)"? "FULL_ACCESS": "READ_ONLY",
        userId: this.$store.state.user.id,
        brokerName: brokerName,
        brokerAccountIdentifier: this.accountId,
        accountType : this.typeChoosed.toUpperCase()
      };
      this.loading = true;
      await BrokerApiCredentialRepo.addApiCredential(apiCredential).then((response) => {
        if (response.status < 400) {
          this.modalType = "success";
          this.modalText = this.$t('modal.success.text',{totalTrades: response.data});
          this.modalTitle = this.$i18n.messages[this.$i18n.locale]["modal"][this.modalType]["title"];
          this.modalSyncedV = true;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.modalType = "error";
        this.modalText = this.$t('modal.error.text');
        this.modalTitle = this.$i18n.messages[this.$i18n.locale]["modal"][this.modalType]["title"];
        this.modalSyncedV = true;
        this.$emit(error);
      });

    },
    async addDirectMTIntegratedAccount(){
      let serverGroup;
          await RepositoryBrokerAccount.serverGroupByMTServerDetails(this.server.id).then(res =>(serverGroup = res.data))

          let metaTraderCredentials = {
            server: this.server.host,
            serverName: this.server.name,
            login: this.accountId,
            version: this.server.version,
            platform: this.server.platformId.name,
            groupName: serverGroup[0].groupName,
            accountType: this.typeChoosed.toUpperCase(),
          };
          // metacredential service also create the broker account
          RepositoryMetaTrader.createCredentials(metaTraderCredentials).then((response) => {
            if(response.status < 400) {
              alert(this.$t('createdAlert'));
              this.getAllBrokerAccounts();
            }
          });
          this.$emit('closeWindow');
    },
    async getAllBrokerAccounts(){
      await RepositoryBrokerAccount.allBrokerAccountsOfUser().then((response) => {
              this.setBrokerAccounts(response.data);
            }).catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error.message);
            });
    },
    closeWindow() {
      this.$emit('closeWindow');
    },
    closeAlert() {
      this.modalSyncedV = false;
      if(this.modalType ==='success'){
        this.getAllBrokerAccounts();
        this.closeWindow();
      }
    },
    goToMT5Connect() {
      this.$router.push('/connect-metatrader');
    }
  }
}
</script>



<style scoped>

</style>
